export default __webpack_public_path__ + "static/media/IDN.51b6b558.svg";